import request from '@/utils/request'

// 账户相关接口
export function getApiKeys() {
  return request({
    url: '/account/keys',
    method: 'get'
  })
}

// 获取账户安全信息（API密钥、余额、回调地址等）
export function getAccountSecurity() {
  return request({
    url: '/ums/reseller/account/security',
    method: 'get'
  })
}

export function generateApiKey() {
  return request({
    url: '/account/keys/generate',
    method: 'post'
  })
}

export function updateKeyStatus(id, status) {
  return request({
    url: '/account/keys/status',
    method: 'put',
    data: { id, status }
  })
}

export function getBalance() {
  return request({
    url: '/account/balance',
    method: 'get'
  })
}

// 创建充值订单并获取二维码
export function createRechargeOrder(data) {
  return request({
    url: '/oms/order/recharge-qr-code',
    method: 'post',
    data
  })
}

// 检查充值订单支付状态
export function checkRechargeOrderStatus(orderNo) {
  return request({
    url: `/oms/order/check-recharge-order-status/${orderNo}`,
    method: 'get'
  })
}

export function recharge(data) {
  return request({
    url: '/account/recharge',
    method: 'post',
    data
  })
}

export function changePassword(data) {
  return request({
    url: '/ums/reseller/account/reset-password',
    method: 'put',
    data
  })
}

// 重置API密钥
export function resetApiKey() {
  return request({
    url: '/ums/reseller/account/security/reset',
    method: 'put'
  })
}
